import React, { useState } from "react";
import '../../components/LoginModal/LoginModal.css';
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from 'react-router-dom';
import ForgetPassword from "../ForgetPassword/ForgetPassword";
import { loginUser } from "../../API/Api";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaEye, FaEyeSlash } from "react-icons/fa";

const LoginModal = ({ isOpen, onClose }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [userType, setUserType] = useState("buyer");
    const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState({ email: "", password: "" });
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    if (!isOpen && !isForgotPasswordOpen) return null;

    const validateForm = () => {
        let valid = true;
        let newErrors = { email: "", password: "" };

        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(email)) {
            newErrors.email = <span className="required">Enter a valid email (e.g., user@example.com)</span>;
            valid = false;
        }

        if (password.length < 6) {
            newErrors.password = <span className="required">Password must be at least 6 characters long.</span>;
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };


    const handleLogin = async () => {
        if (validateForm()) {
            setIsLoading(true);

            const loginData = {
                email,
                password,
                userType
            };

            try {
                const response = await loginUser(loginData);
                if (response.status === true) {
                    toast.success(response.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setTimeout(() => {
                        if (response.user.userType == 'buyer') {
                            window.location.href = "/user-details";
                        } else {
                            window.location.href = "/dashboard";
                        }
                        onClose();
                    }, 1000);
                } else {
                    if (response.message) {
                        toast.error(response.message);
                    }
                }
            } catch (error) {
                if (error.response?.data?.message) {
                    toast.error(error.response.data.message);
                } else if (error.message) {
                    toast.error(error.message);
                }
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleUserTypeChange = (e) => {
        setUserType(e.target.value);
    };

    const handleRegisterClick = () => {
        onClose();
        navigate('/register');
    };

    const handleForgotPasswordClick = () => {
        setIsForgotPasswordOpen(true);
    };

    const handleCloseForgotPassword = () => {
        onClose();
        setIsForgotPasswordOpen(false);
    };

    return (
        <div className="loginModalOverlay">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            {!isForgotPasswordOpen && isOpen && (
                <div className="loginModal">
                    <h2 className="loginTitle">Login/Register</h2>

                    <div className="userTypeGroup">
                        <label>
                            <input
                                type="radio"
                                name="userType"
                                value="buyer"
                                checked={userType === "buyer"}
                                onChange={handleUserTypeChange}
                            />
                            Buyer
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="userType"
                                value="seller"
                                checked={userType === "seller"}
                                onChange={handleUserTypeChange}
                            />
                            Seller
                        </label>
                    </div>

                    <div className="inputGroups">
                        <label htmlFor="email">Email</label>
                        <input
                            type="text"
                            id="email"
                            className="loginInput"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {errors.email && <span className="errorText validtext">{errors.email}</span>}
                    </div>

                    <div className="inputGroups">
                        <label htmlFor="password">Password</label>
                        <div className="passwordWrapper-login">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                className="loginInput"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button
                                type="button"
                                className="eyeIcon-login"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {errors.password && <span className="errorText validtext">{errors.password}</span>}
                    </div>
                    <a
                        href="#"
                        className="forgotPasswordLink"
                        onClick={handleForgotPasswordClick}
                    >
                        Forgot password?
                    </a>

                    <button className="loginBtn" onClick={handleLogin} disabled={isLoading}>
                        {isLoading ? "LOGGING IN..." : "LOGIN"}
                    </button>

                    <div className="divider">
                        <span className="lineor"></span>
                        <span className="ordivider">OR</span>
                        <span className="lineor"></span>
                    </div>
                    <button className="registerBtn" onClick={handleRegisterClick}>REGISTER</button>

                    <button className="closeModalBtn" onClick={onClose}>
                        <RxCross2 />
                    </button>
                </div>
            )}

            {isForgotPasswordOpen && (
                <ForgetPassword
                    isOpen={isForgotPasswordOpen}
                    onClose={handleCloseForgotPassword}
                    email={email}
                    userType={userType}
                />
            )}
        </div>
    );
};

export default LoginModal;